import * as constants from '../../constants';
import roundedRectangle from '../../shared-ui/rounded-rectangle';

const width = 140;
const height = 30;
const spacing = 10;
const xCoord = ( width + spacing ) / 2; 

const buttons = [];
const parentContainer = new PIXI.Sprite();

let currentQuestion;

export default class AnswerButton extends PIXI.Sprite {
  static get container() {
   return parentContainer;
  } 

  static loadQuestion( question ) {
    currentQuestion = question;
    question.multiChoiceOptions.forEach(( opt, i ) => {
      buttons[ i ].option = opt;
      buttons[ i ].interactive = true;
    });
  }

  static onQuestionComplete( question ) {
    buttons.forEach(btn => {
      btn.interactive = false;

      if ( question.optionIsCorrectAnswer(btn.option) ) {
        btn.state = 'correct';
      } else if ( question.answer === btn.option ) {
        btn.state = 'incorrect';
      } else {
        btn.state = 'unselected';
      }
    });
  }

  constructor () {
    super();

    buttons.push(this);
    parentContainer.addChild(this);

    this.interactive = true;
    this.cursor = 'pointer';
    this.anchor.set(0.5, 0);

    const x = ( buttons.length % 2 ? -1 : 1 ) * xCoord;
    const y = Math.floor(( buttons.length - 1 ) / 2) * ( height + spacing );
    this.position.set(x, y);

    this.bg = new PIXI.Container();
    this.addChild(this.bg);

    this.label = new PIXI.Text('A x B', {
      font: '15px Open Sans, Arial',
      align: 'center',
      letterSpacing: 1
    });
    this.label.anchor.set(0.5, 0);
    this.label.y = -8;
    this.addChild(this.label);

    this.on('pointerdown', () => {
      if ( currentQuestion.isCompleted ) {
        return;
      }
      const nextState = this.state === 'selected' ? 'unselected' : 'selected';
      buttons.forEach(btn => btn.state = btn === this ? nextState : 'unselected');

      currentQuestion.answer = nextState === 'selected' ? this.option : null;
    });
  }

  set option( val ) {
    this._option = val;
    this.state = 'unselected';
    this.label.text = `${ val[ 0 ] } x ${ val[ 1 ] }`;
  }
  get option() { return this._option; }

  set state( val ) {
    this._state = val;

    const bgColour = ({
      unselected: constants.grey,
      selected: constants.darkestBlue,
      correct: constants.green,
      incorrect: constants.red
    })[ this.state ];

    this.bg.removeChildren();
    this.bg.addChild(roundedRectangle({
      x: -width / 2,
      y: -height / 2,
      w: width,
      h: height,
      r: 4,
      fillColour: bgColour
    }));

    this.label.style.fill = this._state === 'unselected' ? 0x000000 : 0xFFFFFF;
  }
  get state() { return this._state; }
}
